module.exports = __webpack_public_path__ + "static/8-Gym-cd315f51f8d1dd6cc505328d6aa0f9f7.jpg";